import state from '../state';
import { template } from '../utils';

const zh = {
    headerTitle: '腾讯游戏小应用平台文档中心({{editionTitle}})',
    pageTitle: '{{docTitle}}-{{editionTitle}}-小应用平台文档中心',
    'eiditionTitle.row': '海外标准版',
}

const dft = zh;

const en: typeof dft = {
    headerTitle: 'Gamelet Documentation Center ({{editionTitle}})',
    pageTitle: '{{docTitle}}-{{editionTitle}}-Gamelet Documentation Center',
    'eiditionTitle.row': 'ROW',
}

const langs = {
    dft,
    zh,
    en,
}

export const localize = (key: keyof typeof dft, data?: Record<string, string | number>) => {
    const locale = <keyof typeof langs>(state.locale);
    const langData = langs[locale] || langs.dft;
    return data ? template(langData[key], data) : langData[key];
}
